import React, { useCallback, useRef, useState } from 'react';
import clsx from 'clsx';
import { useField } from 'formik';
import { IFormItem } from '../form-item.type';

interface IRadio extends IFormItem {
  id?: string;

  label?: string;

  value: string | number;

  checked?: boolean;

  placeholder?: string;

  className?: string;
}

export function Radio({
  id,
  name,
  label = '',
  value = '',
  checked,
  disabled = false,
  className = '',
  onChange,
}: IRadio) {
  const radioRef = useRef<HTMLInputElement>(null);
  const [field] = useField(name);
  const [isChecked, setIsChecked] = useState<boolean>(checked || field.value === value);
  let isCurrentChecked = checked !== undefined ? checked : isChecked;

  if (radioRef.current && checked === undefined) {
    isCurrentChecked = radioRef.current.checked;
  }

  const handleChange = useCallback(
    (e) => {
      field.onChange(e);
      onChange && onChange(e);
      setIsChecked(e.target.checked);
    },
    [field, onChange]
  );

  const usedId = id || `${Math.random()}`;

  return (
    <>
      <div className='form-checkbox'>
        <input
          ref={radioRef}
          className={clsx('form-check-input', className)}
          type='radio'
          id={usedId}
          value={value}
          name={field.name}
          disabled={disabled}
          checked={isCurrentChecked}
          onChange={handleChange}
          onBlur={field.onBlur}
        />
        <label htmlFor={usedId} className='form-check-label'>
          {label}
        </label>
      </div>
    </>
  );
}
